import type { RunSummary } from "@agentdash/shared";

/**
 * Run-summary preview cell shared by the run tables on LiveView ("Recently
 * completed") and RunList ("All runs"). Shows the first line of the generated
 * summary, a placeholder while summarization is pending, or a failure marker —
 * truncated to a single line with the full summary in the title tooltip.
 *
 * Renders a `<td>`, so it must be used inside a table row.
 */
export function SummaryCell({ run }: { run: RunSummary }) {
  const firstLine = (run.summary ?? "").split("\n")[0] ?? "";
  const preview =
    run.summary_status === "pending"
      ? "…summarizing"
      : run.summary_status === "error"
        ? "⚠ summary failed"
        : firstLine;
  return (
    <td
      data-label="Summary"
      title={run.summary ?? run.summary_error ?? ""}
      className="summary-cell"
      style={{
        maxWidth: 360,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        color:
          run.summary_status === "error"
            ? "var(--err)"
            : run.summary_status === "pending"
              ? "var(--muted)"
              : undefined,
      }}
    >
      {preview || "—"}
    </td>
  );
}
